import { TransformedCard } from '@/shared/api/lib/utils/transform-program';

export function deleteEmptyFieldsPdf(cards: TransformedCard[]) {
    return cards.map((card) => {
        const cleanedCard = Object.keys(card).reduce<Partial<TransformedCard>>((acc, key) => {
            const value = card[key as keyof TransformedCard];
            if (
                value != null &&
                value !== '' &&
                !(Array.isArray(value) && value.length === 0) &&
                !(typeof value === 'object' && value !== null && Object.keys(value).length === 0)
            ) {
                acc[key as keyof TransformedCard] = value as any;
            }
            return acc;
        }, {}) as TransformedCard;
        return cleanedCard;
    });
}
